import React from 'react';

type Properties = {
    toggleExpandCoach: () => void,
    avatarImagePath: string,
    isHidden?: boolean
};

const CoachAvatar = (props: Properties) => {
    if (props.isHidden) {
        return <></>;
    }

    const getImage = React.useCallback(() => {
        const image = require('../../../../../static/i-pregno/coaches/' + props.avatarImagePath);
        return image;
    }, [props.avatarImagePath]);

    return (
        <div className="page-coach">
            <div className="coach-circle" onClick={props.toggleExpandCoach} data-testid="coachAvatar-container">
                <img src={getImage()} />
            </div>
        </div>
    );
};

export default CoachAvatar;
